import React from 'react';
import { 
  Mail, 
  MapPin, 
  Award, 
  Star,
  User
} from 'lucide-react';
import { rameshChandPhoto, sameepProfileImage, vijayProfileImage, saurabhProfileImage } from '../assets/images';
import '../styles/team.css';

const Team = () => {
  const chiefMentor = {
    id: 'mentor-1',
    name: 'Prof. (Dr.) Ramesh Chand Arya',
    title: 'Chief Surgical Mentor & Traditional Knowledge Authority',
    qualification: 'Former Professor & Head, Department of Shalya Tantra',
    institution: 'Reputed Ayurvedic medical institutions',
    image: rameshChandPhoto,
    bio: 'Prof. (Dr.) Ramesh Chand Arya is a senior Shalya Tantra surgeon, academician, and postgraduate mentor with more than four decades of experience in Ayurvedic surgical practice and medical education. He has performed over 30,000 surgical procedures and has contributed extensively to the advancement of Ayurvedic surgery through clinical practice, teaching, and research. He served as Professor and Head of Department in reputed Ayurvedic medical institutions and has guided numerous postgraduate scholars in Shalya Tantra. His expertise spans general surgery, proctology, colorectal procedures, and classical Kshar Sutra therapy. At Vedic Surgery AI, he provides academic mentorship and traditional surgical guidance to ensure authenticity, clinical relevance, and adherence to classical Ayurvedic surgical principles within AI-assisted educational frameworks.',
    academicContributions: [
      '40+ years of surgical and teaching experience',
      'Former Professor & Head, Shalya Tantra',
      '30,000+ successful surgeries performed',
      'Postgraduate guide for 50+ scholars',
      'Author of A Manual of Kshar Sutra Karma',
      'Published 50+ research articles in reputed journals',
      'Expert member in academic and professional selection boards'
    ],
    roleAtVedicSurgery: [
      'Academic supervision of surgical knowledge modules',
      'Validation of Shalya Tantra concepts integrated into AI systems',
      'Mentorship in clinical protocol development',
      'Guidance for ethical and evidence-aligned surgical education'
    ]
  };

  const founders = [
    {
      id: 1,
      name: "Dr. Sameep Singh",
      title: "Founder",
      qualification: "BAMS, PG Scholar (MS Shalya Tantra)",
      institution: "Quadra Institute of Ayurveda & Hospital, Roorkee",
      responsibilities: [
        "Vision and academic leadership of Vedic Surgery AI",
        "Development of AI-assisted surgical education modules",
        "Integration of classical Shalya Tantra principles with modern learnings",
        "Research design, academic content development, and validation",
        "Clinical and academic collaboration coordination"
      ],
      specialties: ["Classical Surgery", "Research & Innovation"],
      email: "sameep@vedicsurgery.org",
      location: "Roorkee, Uttarakhand",
      image: sameepProfileImage,
      bio: "Dr. Sameep Singh is an emerging Ayurvedic surgeon and researcher specializing in Shalya Tantra, currently pursuing postgraduate training with a focus on wound care, anorectal surgery, and integrative surgical sciences. His work centers on bridging traditional Ayurvedic wisdom with contemporary medical education to advance surgical training and research accessibility. He has presented research at national and international conferences and contributes actively to evidence-based Ayurveda through publications and academic writing.",
      achievements: [
        "Presented at national and international academic conferences",
        "Multiple research papers and publications",
        "Clinical research and textbook authorship",
        "Founder of Vedic Surgery AI"
      ]
    },
    {
      id: 2,
      name: "Vijay Pratap Singh",
      title: "Co-Founder & Project Head",
      qualification: "C# Corner MVP, Gen AI Leader",
      institution: "Technical Leadership",
      responsibilities: [
        "Platform Architecture & Development",
        "AI Integration & Implementation",
        "Technical Strategy & Innovation",
        "Team Leadership & Mentorship"
      ],
      specialties: ["Full Stack Development", "AI/ML", "Cloud Architecture", "Product Engineering"],
      email: "vijaypratap12121999@gmail.com",
      location: "Noida, Uttar Pradesh",
      image: vijayProfileImage,
      bio: "Vijay Pratap Singh is a product engineer and technical leader specializing in full-stack development, AI/ML, and cloud architecture, with over four years of experience building scalable platforms and AI-powered applications. He is the Co-Founder and Project Head of Vedic Surgery AI, driving the platform’s architecture, development, and integration of generative AI and modern web technologies. His work focuses on turning the initiative’s vision into a robust, user-friendly product that supports Ayurvedic surgical education through intelligent tools and seamless experiences.",
      achievements: [
        "C# Corner MVP",
        "Gen AI Leader",
        "4+ years in software development"
      ]
    }
  ];

  const leadership = [
    {
      id: 3,
      name: "Prof. (Dr.) Saurabh Kumar",
      title: "Chief Author & Senior Clinical Advisor",
      qualification: "BAMS, MS (Shalya Tantra)",
      institution: "Professor, Postgraduate Guide & Additional Director, Ayurvedic institutions",
      responsibilities: [
        "Chief Author & Senior Clinical Advisor at Vedic Surgery AI",
        "Validation of content for Ayurvedic surgical education modules",
        "Research supervision, academic policy & ethics committees",
        "Surgical education, ano-rectal procedures & emergency services"
      ],
      specialties: ["Clinical Practice", "Surgical Techniques", "Medical Education"],
      email: "saurabh@vedicsurgery.org",
      location: "India",
      image: saurabhProfileImage,
      bio: "Prof. (Dr.) Saurabh Kumar is a senior Ayurvedic surgeon specializing in Shalya Tantra, serving as Professor, Postgraduate Guide, and Additional Director at Ayurvedic institutions. He has held roles as Head of Department, Dean, Principal, and academic leader, with expertise in surgical education, ano-rectal procedures, and emergency services. He contributes to research supervision, academic policy, ethics committees, and university examinations. At Vedic Surgery AI, he acts as Chief Author and Senior Clinical Advisor, validating content for Ayurvedic surgical education modules.",
      achievements: [
        "Head of Department, Dean & Principal at Ayurvedic institutions",
        "20+ years clinical and academic experience",
        "Expertise in surgical education and university examinations"
      ]
    }
  ];

  const advisoryPanel = [
    {
      name: "Dr. Mahesh Pande",
      title: "Senior Surgical Advisor",
      specialty: "Endourology + Ayurveda",
      responsibility: "Modern surgical expertise, procedure-based guidance",
      institution: "Leading Medical Institute",
      status: "To be confirmed"
    },
    {
      name: "Dr. Deepanshu Kumar Mishra",
      title: "Academic Advisor", 
      specialty: "NCISM Curriculum",
      responsibility: "NCISM syllabus alignment, textbook mentorship",
      institution: "Guru Nanak Ayurvedic Medical College, Muktsar",
      status: "To be confirmed"
    },
    {
      name: "AI Policy Consultant",
      title: "Ayurveda AI Ethics & Research Expert",
      specialty: "AI Ethics in Traditional Medicine",
      responsibility: "Oversight on AI integration in traditional systems",
      institution: "Independent / AYUSH / NCISM",
      status: "To be filled"
    }
  ];


  return (
    <div className="team-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content text-center">
            <h1>Our Team</h1>
            <p>
              Meet the passionate experts, educators, and innovators behind the Vedic Surgery project - 
              dedicated to revolutionizing Ayurvedic surgical education.
            </p>
          </div>
        </div>
      </section>

      {/* Chief Surgical Mentor & Traditional Knowledge Authority */}
      <section className="section section-alt">
        <div className="container">
          <div className="content-header">
            <h2>Chief Surgical Mentor</h2>
            <p>Senior Shalya Tantra expertise guiding authenticity and clinical relevance in AI-assisted education</p>
          </div>

          <div className="leadership-grid leadership-grid--single">
            <div className="leader-card card">
              <div className="leader-header">
                <div className="leader-image">
                  <img src={chiefMentor.image} alt={chiefMentor.name} className="leader-photo" />
                </div>
                <div className="leader-info">
                  <h3>{chiefMentor.name}</h3>
                  <p className="leader-title">{chiefMentor.title}</p>
                  <p className="leader-qualification">{chiefMentor.qualification}</p>
                  <p className="leader-institution">{chiefMentor.institution}</p>
                </div>
              </div>

              <div className="leader-bio">
                <p>{chiefMentor.bio}</p>
              </div>

              <div className="leader-responsibilities">
                <h5>Role at Vedic Surgery AI</h5>
                <ul>
                  {chiefMentor.roleAtVedicSurgery.map((item, index) => (
                    <li key={index}>
                      <Award size={14} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="leader-achievements">
                <h5>Key Academic Contributions</h5>
                <ul>
                  {chiefMentor.academicContributions.map((item, index) => (
                    <li key={index}>
                      <Star size={14} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="section">
        <div className="container">
          <div className="content-header">
            <h2>Founders</h2>
            <p>Visionary leaders pioneering the integration of classical Ayurvedic wisdom with cutting-edge technology</p>
          </div>

          <div className="leadership-grid">
            {founders.map((founder) => (
              <div key={founder.id} className="leader-card card">
                <div className="leader-header">
                  <div className="leader-image">
                    {founder.image ? (
                      <img src={founder.image} alt={founder.name} className="leader-photo" />
                    ) : (
                      <div className="image-placeholder">
                        <User size={48} />
                      </div>
                    )}
                  </div>
                  <div className="leader-info">
                    <h3>{founder.name}</h3>
                    <p className="leader-title">{founder.title}</p>
                    <p className="leader-qualification">{founder.qualification}</p>
                    <p className="leader-institution">{founder.institution}</p>
                  </div>
                </div>

                <div className="leader-bio">
                  <p>{founder.bio}</p>
                </div>

                <div className="leader-responsibilities">
                  <h5>Key Responsibilities:</h5>
                  <ul>
                    {founder.responsibilities.map((responsibility, index) => (
                      <li key={index}>
                        <Award size={14} />
                        <span>{responsibility}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="leader-specialties">
                  <h5>Specialties:</h5>
                  <div className="specialty-tags">
                    {founder.specialties.map((specialty, index) => (
                      <span key={index} className="specialty-tag">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="leader-achievements">
                  <h5>Key Achievements:</h5>
                  <ul>
                    {founder.achievements.map((achievement, index) => (
                      <li key={index}>
                        <Star size={14} />
                        <span>{achievement}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="leader-contact">
                  <div className="contact-item">
                    <Mail size={16} />
                    <span>{founder.email}</span>
                  </div>
                  <div className="contact-item">
                    <MapPin size={16} />
                    <span>{founder.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Leadership */}
      <section className="section section-alt">
        <div className="container">
          <div className="content-header">
            <h2>Project Leadership</h2>
            <p>Expert advisors and clinical leaders guiding content development and quality assurance</p>
          </div>

          <div className="leadership-grid">
            {leadership.map((leader) => (
              <div key={leader.id} className="leader-card card">
                <div className="leader-header">
                  <div className="leader-image">
                    {leader.image ? (
                      <img src={leader.image} alt={leader.name} className="leader-photo" />
                    ) : (
                      <div className="image-placeholder">
                        <User size={48} />
                      </div>
                    )}
                  </div>
                  <div className="leader-info">
                    <h3>{leader.name}</h3>
                    <p className="leader-title">{leader.title}</p>
                    <p className="leader-qualification">{leader.qualification}</p>
                    <p className="leader-institution">{leader.institution}</p>
                  </div>
                </div>

                <div className="leader-bio">
                  <p>{leader.bio}</p>
                </div>

                <div className="leader-responsibilities">
                  <h5>Key Responsibilities:</h5>
                  <ul>
                    {leader.responsibilities.map((responsibility, index) => (
                      <li key={index}>
                        <Award size={14} />
                        <span>{responsibility}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="leader-specialties">
                  <h5>Specialties:</h5>
                  <div className="specialty-tags">
                    {leader.specialties.map((specialty, index) => (
                      <span key={index} className="specialty-tag">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="leader-achievements">
                  <h5>Key Achievements:</h5>
                  <ul>
                    {leader.achievements.map((achievement, index) => (
                      <li key={index}>
                        <Star size={14} />
                        <span>{achievement}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="leader-contact">
                  <div className="contact-item">
                    <Mail size={16} />
                    <span>{leader.email}</span>
                  </div>
                  <div className="contact-item">
                    <MapPin size={16} />
                    <span>{leader.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Panel */}
      <section className="section">
        <div className="container">
          <div className="content-header">
            <h2>Advisory & Mentorship Panel</h2>
            <p>Distinguished experts providing strategic guidance and domain expertise</p>
          </div>

          <div className="advisory-grid grid grid-3">
            {advisoryPanel.map((advisor, index) => (
              <div key={index} className="advisor-card card">
                <div className="advisor-header">
                  <h4>{advisor.name}</h4>
                  <p className="advisor-title">{advisor.title}</p>
                  <span className={`status-badge badge ${
                    advisor.status === 'To be confirmed' ? 'badge-warning' : 'badge-info'
                  }`}>
                    {advisor.status}
                  </span>
                </div>
                
                <div className="advisor-details">
                  <div className="detail-item">
                    <strong>Specialty:</strong>
                    <span>{advisor.specialty}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Institution:</strong>
                    <span>{advisor.institution}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Responsibility:</strong>
                    <p>{advisor.responsibility}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Team; 